import {connect} from 'react-redux';
import ReserveSquads from './ReserveSquads.jsx';
import {
  handleTournamentChange,
  handleDateSelection,
  handleReviewReservationsClick
} from './actions';

const mapStateToProps = state => ({
  tournaments: state.admin.schedule.tournaments,
  tournamentId: state.admin.base.tournament ? state.admin.base.tournament.id : null,
  tournamentName: state.admin.base.tournament ? state.admin.base.tournament.name : '',
  noDatesAvailable: state.admin.schedule.noDatesAvailable
});

const mapDispatchToProps = dispatch => ({
  onTournamentChange: tournamentId => dispatch(handleTournamentChange(tournamentId)),
  onSelectDate: date => dispatch(handleDateSelection(date)),
  onReviewReservations: () => dispatch(handleReviewReservationsClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(ReserveSquads);



// WEBPACK FOOTER //
// ./src/features/admin/schedule/ReserveSquadsContainer.jsx